import ResultOfferCard from './ResultOfferCard';
import { formatResultDate, locationCode } from '../../utils/resultDisplay';
import { SITE_NAME } from '../../constants/site';

export default function PackageResultCard({ item, searchParams }) {
  const destCode = locationCode(item.destination);
  const bookingLines = [
    { label: 'Package', value: item.title },
    { label: 'Destination', value: item.destination },
    { label: 'Nights', value: String(item.nights) },
    { label: 'Total price', value: `$${item.price.toFixed(2)}` },
  ];

  return (
    <ResultOfferCard
      dateLabel={formatResultDate(searchParams?.get('depart'))}
      providerName={item.title}
      providerFallback={destCode}
      routeLeft={{ code: destCode, time: 'Depart' }}
      routeRight={{ code: 'PKG', time: formatResultDate(searchParams?.get('return')) }}
      routeDuration={`${item.nights} nights`}
      routeStops={item.includes?.join(' · ')}
      price={{ amount: item.perPerson ?? item.price, currency: 'USD' }}
      pricePerLabel="Price per person"
      priceFinePrint={`Package total $${Number(item.price).toFixed(2)} (incl. taxes & fees)`}
      detailsTitle="Package Details"
      detailRows={[
        { label: 'Destination', value: item.destination },
        { label: 'Includes', value: item.includes?.join(', ') },
      ]}
      bookNowProps={{
        serviceType: 'package',
        bookingPayload: {
          subject: `${SITE_NAME} — Package booking`,
          bookingLines,
          offer: {
            title: item.title,
            destination: item.destination,
            nights: item.nights,
            includes: item.includes?.join(', '),
          },
          price: {
            base: item.perPerson ?? item.price,
            total: item.price,
            travelerLabel: '1 Traveler(s)',
          },
        },
      }}
    />
  );
}
